declare global { interface Window { clarity: any; } }

export function clarityTrack(eventName: string): void {
    if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
    }
}

export function claritySet(key: string, value: string | number): void {
    if (typeof window.clarity === 'function') {
        window.clarity('set', key, String(value));
    }
}
